import React from 'react';
import { Container } from '@ui';
import { Separator } from '@ui';
import { PrettyJSON } from '@ui/text/PrettyJSON';
import { TransparentFlatButton } from '@ui/buttons';
import styled from 'styled-components';

const StepJsonDisplayWrapper = styled.div`
  margin: 8px auto 0 auto;
  opacity: 0.2;
  text-align: center;
`;

export const StepJsonDisplay = ({ data }) => {
  const [showStepJson, setShowStepJson] = React.useState(false);
  const onShowJsonClick = () => {
    setShowStepJson(!showStepJson);
  };
  if (showStepJson) {
    return (
      <Container top={24} style={{ wordBreak: 'break-word' }}>
        <Separator />
        <Container top={16}>
          <PrettyJSON value={data.planStepData} />
        </Container>
      </Container>
    );
  }
  return (
    <StepJsonDisplayWrapper>
      <TransparentFlatButton onClick={onShowJsonClick}>Show Step JSON</TransparentFlatButton>
    </StepJsonDisplayWrapper>
  );
};
